import { IntlShape } from 'react-intl';

/**
 * Stripe error / issuer decline codes the BE returns for an inline card checkout whose charge was
 * declined (`Order.errorMessage` on the checkout response, `Order.lastPaymentErrorCode` on later
 * reads of the PENDING order), mapped to customer-facing messages. Anything not listed falls back
 * to the generic decline text; codes Stripe says never to show the cardholder (`stolen_card`,
 * `fraudulent`, …) are already collapsed to `generic_decline` by the BE.
 */
const CARD_FAILURE_MESSAGE_IDS: Record<string, string> = {
  card_declined: 'checkout.card.declined.generic',
  generic_decline: 'checkout.card.declined.generic',
  do_not_honor: 'checkout.card.declined.generic',
  transaction_not_allowed: 'checkout.card.declined.generic',
  insufficient_funds: 'checkout.card.declined.insufficient_funds',
  expired_card: 'checkout.card.declined.expired_card',
  incorrect_cvc: 'checkout.card.declined.incorrect_cvc',
  invalid_cvc: 'checkout.card.declined.incorrect_cvc',
  incorrect_number: 'checkout.card.declined.incorrect_number',
  invalid_number: 'checkout.card.declined.incorrect_number',
  processing_error: 'checkout.card.declined.processing_error',
  authentication_required: 'checkout.card.declined.authentication_required',
  payment_intent_authentication_failure: 'checkout.card.declined.authentication_required',
  'payment.method.invalid': 'checkout.card.declined.payment_method_invalid',
  'payment.method.not.found': 'checkout.card.declined.payment_method_not_found',
};

export const GENERIC_CARD_FAILURE_MESSAGE_ID = 'checkout.card.declined.generic';

export const describeCardFailure = (intl: IntlShape, code?: string | null): string => {
  const messageId = (code && CARD_FAILURE_MESSAGE_IDS[code])
    || (code && intl.messages[code] ? code : GENERIC_CARD_FAILURE_MESSAGE_ID);
  return intl.formatMessage({ id: messageId });
};
